module.exports = __webpack_public_path__ + "files/47971e32756011041c90e88564403307.png";